import React from 'react';

export function Spain(props) {
  return (
    <svg width="513" height="342" viewBox="0 0 513 342" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0H513V85.5H0V0Z" fill="#AA151B"/>
      <path d="M0 85.5H513V256.5H0V85.5Z" fill="#F1BF00"/>
      <path d="M0 256.5H513V342H0V256.5Z" fill="#AA151B"/>
    </svg>
  );
}
